import styled from "styled-components"

export const StyledAttribute = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;

  &:nth-of-type(1) {
    margin-top: 0;
  }
`

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 18px;
  min-width: 18px;
  margin-right: 16px;
`

export const StyledTitle = styled.div`
`